<template>
    <div>
        <div v-for="index in getRandomValue(2,4)" :key="index">
            <b-card class="rounded shadowed w-100 mb-4">
                <div class="row">
                    <div class="col-12 mb-3">
                        <div class="d-flex justify-content-end">
                            <b-skeleton type="button" width="15%"></b-skeleton>
                        </div>
                    </div>
                </div>
                <div v-for="inputIndex in getRandomValue(3,5)" :key="inputIndex">
                    <div class="row mb-3" v-if="isFullWidthColumn()">
                        <div class="col-12">
                            <b-skeleton type="text" :width="`${getRandomValue(30,50)}%`" class="mb-2"></b-skeleton>
                            <b-skeleton type="input"></b-skeleton>
                        </div>
                    </div>
                    <div class="row mb-3" v-else>
                        <div class="col-6">
                            <b-skeleton type="text" :width="`${getRandomValue(30,50)}%`" class="mb-2"></b-skeleton>
                            <b-skeleton type="input"></b-skeleton>
                        </div>
                        <div class="col-6">
                            <b-skeleton type="text" :width="`${getRandomValue(30,50)}%`" class="mb-2"></b-skeleton>
                            <b-skeleton type="input"></b-skeleton>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mt-3">
                        <div class="d-flex justify-content-end">
                            <b-skeleton type="button" width="30%"></b-skeleton>
                        </div>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
export default {
    name: "RandomFormSkeleton",
    methods:{
        getRandomValue(min,max){
            return Math.floor(Math.random() * (max - min) ) + min;
        },
        isFullWidthColumn(){
            return this.getRandomValue(0,5) > 2;
        }
    }
}
</script>